export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: null,
    },
    preserve: {
      type: Boolean,
      default: true,
    },
  },
};
